import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Select } from '../components/ui/Select';
export function EditSectionQuestion() {
  return <div className="space-y-6 max-w-3xl mx-auto" data-id="element-272">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-273">
        Edit Section Question
      </h1>

      <Card data-id="element-274">
        <CardContent className="space-y-6 pt-6" data-id="element-275">
          <Select label="Course" options={[{
          value: '1',
          label: 'Desert Ecology Basics'
        }, {
          value: '2',
          label: 'Advanced Water Conservation'
        }]} data-id="element-276" />

          <Select label="Section" options={[{
          value: '1',
          label: 'Section 1'
        }, {
          value: '2',
          label: 'Section 2'
        }]} data-id="element-277" />

          <div className="space-y-1" data-id="element-278">
            <label className="block text-sm font-medium text-slate-700" data-id="element-279">
              Question
            </label>
            <textarea className="w-full min-h-[120px] rounded-md border border-slate-300 p-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" defaultValue="What is the primary water source for desert flora?" data-id="element-280" />
          </div>

          <div className="space-y-2" data-id="element-281">
            <label className="block text-sm font-medium text-slate-700" data-id="element-282">
              Answer
            </label>
            <div className="flex items-center gap-6" data-id="element-283">
              <label className="flex items-center gap-2" data-id="element-284">
                <input type="radio" name="answer" value="yes" defaultChecked className="text-slate-900 focus:ring-slate-900" data-id="element-285" />
                <span className="text-sm text-slate-700" data-id="element-286">Yes</span>
              </label>
              <label className="flex items-center gap-2" data-id="element-287">
                <input type="radio" name="answer" value="no" className="text-slate-900 focus:ring-slate-900" data-id="element-288" />
                <span className="text-sm text-slate-700" data-id="element-289">No</span>
              </label>
            </div>
          </div>

          <div className="pt-4" data-id="element-290">
            <Button data-id="element-291">Submit</Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}